
/* 增加测试环境 */
// api.digisign.btsjkj.cn 海外正式
//     sxapi.btsjkj.cn 本地正式
const IS_WORLD = true;
const config = {
    test: {
        // ajaxDefaults: '192.168.11.10:8916',
        ajaxDefaults: 'sxapi.btsjkj.cn',
        // ajaxDefaults: 'api.digisign.btsjkj.cn',
    },
    prod: {
        ajaxDefaults: IS_WORLD?'api.digisign.btsjkj.cn':'sxapi.btsjkj.cn',
        // ajaxDefaults: 'api.digisign.btsjkj.cn',
        // ajaxDefaults: '192.168.11.10:8916', 
    }
}
// sxapi.btsjkj.cn
export default {
    official: true,
    isWorld: IS_WORLD,
    appName: IS_WORLD?"TeleCMS":"E-发布",
    ...config[process.env.URL_ENV],
};